/* Carelli — Hero Parallax
   Scroll-driven vertical parallax on the hero image */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var el = document.querySelector('[data-hero-parallax]');
  if (!el) return;

  var speed = 0.12;
  var ticking = false;
  var maxScroll = window.innerHeight * 1.5;

  function update() {
    var y = window.scrollY;
    if (y < maxScroll) {
      el.style.transform = 'translate3d(0,' + (y * speed) + 'px,0)';
    }
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });
})();
